// extracted by mini-css-extract-plugin
module.exports = {"root":"IconVisual__root___BpMZX","muted":"IconVisual__muted___m7zRR","tight":"IconVisual__tight___JO_PK"};